import { tools } from './../helpers/tools';
import { storage } from './../helpers/storage';
import { settings } from './../settings';
import { ConfigurationResponse } from '../api/models';
import ajax from '../api/ajax';

class Configuration {
    constructor(domain) {
        this.url = {
            domain: domain,
            path: '',
        };
    }
    
    init() {
        this.url.domain = settings.settings.acf[`configuration_api_url`];
    }

    /**
     * Remove configuration from session storage
     */
    destroy() {
        storage.remove('configuration');
    }

    /**
     * Get configuration.
     * @return {Promise<ConfigurationResponse>} promise
     */
    get() {
        const self = this;
        
        return new Promise((resolve, reject) => {
            const stored = storage.get('configuration');
            
            if (stored) {
                resolve(new ConfigurationResponse(JSON.parse(stored)));

                return;
            }

            return ajax.get(self, 'configuration').then((configuration) => {
                const response = new ConfigurationResponse(configuration);

                if (configuration) {
                    storage.set('configuration', JSON.stringify(configuration));

                    resolve(response);
                } else {
                    self.destroy();

                    reject(response);
                }
            }).catch((error) => {
                const response = new ConfigurationResponse().failed(error);

                tools.handleError(self, response);

                reject(response);
            });
        });
    }

    /**
     * Validate discount code. An empty discount code
     * is considered to be valid.
     * @param {Configuration} config The configuration to validate against
     * @param {ValueText} campaignCode
     * @return {Boolean} True if code is valid
     */
    validateCampaignCode(config, campaignCode) {
        if (!campaignCode) {
            return true;
        }
        
        campaignCode = campaignCode.toLowerCase();

        let valid = false;

        if (config.campaignCodes) {
            const now = new Date();

            config.campaignCodes.forEach((code) => {
                if (tools.toDate(code.startDate) <= now && 
                    tools.toDate(code.endDate) >= now &&
                    campaignCode == code.campaignCode.toLowerCase()) {
                        valid = true;
                }
            });
        }

        return valid;
    }

    sendOtp(data) {
        const url = `configuration/send/otp`;
        const self = this;
        
        return new Promise((resolve, reject) => {
            
            return ajax.post(self, url, true, JSON.stringify(data)).then((response) => {

               resolve(response);
            })
            .catch((error) => {
                const response = new ConfigurationResponse().failed(error);

                tools.handleError(self, response);

                reject(response);
            });
        });
    }

    verifyOtp(data) {
        const url = `configuration/verify/otp`;
        const self = this;
        
        return new Promise((resolve, reject) => {


            return ajax.post(self, url, true, JSON.stringify(data)).then((response) => {

               resolve(response);
               //console.log(response);
            })
            .catch((error) => {
                const response = new ConfigurationResponse().failed(error);

                tools.handleError(self, response);

                reject(response);
            });
        });
    }
}

export let configuration = new Configuration();


// WEBPACK FOOTER //
// ./scripts/booking/api/configuration.js